export default function PrivacyDetails() {
    return (
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-4">Privacy Details</h1>
        <ul className="list-disc pl-6 space-y-2">
          <li>Types of data collected (contact info, site analytics).</li>
          <li>Purposes (service delivery, security, performance).</li>
          <li>Sharing (service providers, legal compliance).</li>
          <li>Retention periods and security measures.</li>
          <li>How to exercise rights & contact AllWell.</li>
        </ul>
      </div>
    );
  }
  